import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from "react-router-dom";
import HomePg from './pages/Home/Home';
import ComingSoonPg from './pages/ComingSoon/ComingSoon';
import './assets_global/scss/normalize.scss';
import './assets_global/scss/styles.scss';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" render={(props) => <ComingSoonPg {...props} />}
        />

      </Switch>
    </Router>
  );
}

export default App;
